import React from "react";

const LineItem = ({ item, order, egiftcard }) => {
    const fallbackImageUrl = "https://static.koboscm.com/images/RakutenKobo/devices/image-not-found.png";
    const itemPictureUrl = `https://static.koboscm.com/images/RakutenKobo/devices/${item.sku}.png`;

    const getFilterProtectionLineItemName = protectionLineItem => {
        let firstPart = protectionLineItem.name.slice(0, protectionLineItem.name.indexOf("-")).replace("Clyde", "").replace("XCover", "");
        let secondPart = "";

        if (protectionLineItem.properties && protectionLineItem.properties.some(p => p.name === "Reference")) {
            let referenceItem = order.line_items.filter(
                li => li.requires_shipping === true && li.variant_id.toString() === protectionLineItem.properties.filter(p => p.name === "Reference")[0].value
            )[0];

            if (referenceItem) {
                secondPart = referenceItem.name;
            }
        }

        return `${firstPart}${secondPart !== "" ? " - " + secondPart : ""}`;
    };

    const getFilterProtectionLineItemYear = protectionLineItem => {
        let yearsCoverage = protectionLineItem.name.substring(protectionLineItem.name.indexOf("/") + 1);
        return yearsCoverage;
    };

    const isLineItemProtection = lineItem => {
        return lineItem.requires_shipping === false && !lineItem.sku.includes("EGIFTCARD");
    };

    const getFilteredLineItemName = lineItem => {
        if (isLineItemProtection(lineItem)) {
            return getFilterProtectionLineItemName(lineItem);
        } else {
            return lineItem.title;
        }
    };
    const getFilteredLineItemVariantTitle = lineItem => {
        return null;
        if (isLineItemProtection(lineItem)) {
            return getFilterProtectionLineItemYear(lineItem);
        } else {
            return lineItem.variant_title;
        }
    };
    const getFilteredLineItemVariant = lineItem => {
        if (isLineItemProtection(lineItem)) {
            return getFilterProtectionLineItemYear(lineItem);
        } else {
            return lineItem.variant_title;
        }
    };

    const variantTitle = getFilteredLineItemVariantTitle(item);
    const variantName = getFilteredLineItemVariant(item);
    const productName = getFilteredLineItemName(item);

    return (
        <div className="line-item-container">
            <div className="line-items-column-1">
                <img className="order-item-image" src={itemPictureUrl} alt={item.title} onError={e => (e.target.src = fallbackImageUrl)} />
                <div className="layout vertical">
                    <span className="line-item-title">{productName}</span>
                    {!egiftcard && variantName && (
                        <span className="line-item-variant-name">
                            {variantTitle}
                            {variantName}
                        </span>
                    )}
                    <span className="line-item-price-mobile">{item.price_formatted || item.price}</span>
                </div>
            </div>
            <div className="line-items-column-2">
                <span className="line-item-quantity">{item.quantity}</span>
            </div>
            <div className="line-items-column-3">
                <span className="line-item-price">{item.price_formatted || item.price}</span>
            </div>
        </div>
    );
};

export default LineItem;



// WEBPACK FOOTER //
// ./src/views/Order/components/_LineItem.jsx